export default __webpack_public_path__ + "static/media/levenspad_EN_pc2.4d04da8f.png";